/** A fixed server deadline; visiting or reloading never starts a new timer. */
export const remainingPromotionTime = (deadline, now = Date.now()) => {
    const remaining = Math.max(0, Math.ceil((Number(deadline) * 1000 - now) / 1000));
    if (!Number.isFinite(remaining)) return { expired: true, text: '' };
    const days = Math.floor(remaining / 86400);
    const clock = [Math.floor(remaining % 86400 / 3600), Math.floor(remaining % 3600 / 60), remaining % 60]
        .map((part) => String(part).padStart(2, '0')).join(':');
    return { expired: remaining === 0, days, text: clock };
};
